import type { Candidate, CandidateRedux } from '@axiom/validation';
import { CurrencyUtil } from '@axiom/utils';
import type { CurrencyCodeValueTypes } from '@axiom/const';

export const TalentProfileDetailCompensationUtil = {
  calculateEstimatedHourlyRate(
    talent: CandidateRedux | Candidate,
    currencyCode: CurrencyCodeValueTypes
  ) {
    const { displayLowHourlyRate, displayHighHourlyRate } = talent;
    if (!displayLowHourlyRate || !displayHighHourlyRate) {
      return '--';
    }
    return `${CurrencyUtil.getFormattedCurrency({
      value: displayLowHourlyRate,
      currencyCode,
    })} - ${CurrencyUtil.getFormattedCurrency({ value: displayHighHourlyRate, currencyCode })}`;
  },
  calculateEstimatedDailyRate(
    talent: CandidateRedux | Candidate,
    currencyCode: CurrencyCodeValueTypes
  ) {
    const { displayLowHourlyRate, displayHighHourlyRate, hoursPerDay } = talent;
    if (!displayLowHourlyRate || !displayHighHourlyRate || !hoursPerDay) {
      return '--';
    }
    const rate = `${CurrencyUtil.getFormattedCurrency({ value: Number.parseFloat(displayLowHourlyRate) * hoursPerDay, currencyCode })} - ${CurrencyUtil.getFormattedCurrency({ value: Number.parseFloat(displayHighHourlyRate) * hoursPerDay, currencyCode })}`;
    return `${rate} (Hourly x ${hoursPerDay})`;
  },
  calculateEstimatedMonthlyRate(
    talent: CandidateRedux | Candidate,
    currencyCode: CurrencyCodeValueTypes
  ) {
    if (!talent.displayWeeklyRate) return '--';

    return CurrencyUtil.getFormattedCurrency({
      value: Math.round(Number.parseFloat(talent.displayWeeklyRate) * 4.35),
      currencyCode,
    });
  },
};
